<ng-template #filtersForm>
    <div class="invoices-header-right">
        <form
            class="invoices-filters"
            [formGroup]="invoicesFiltersFormGroup"
            *ngIf="supplierFilterOptions$ | async"
        >
            <div class="invoices-filters-invoice-number">
                <lsq-input
                    placeholder="Search Invoice Number"
                    formControlName="invoiceNumber"
                    [name]="'invoiceNumber'"
                    [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                    [group]="invoicesFiltersFormGroup"
                >
                </lsq-input>
            </div>
            <lsq-multi-select
                *ngIf="supplierFilterOptions$ | async"
                class="invoices-filters-suppliers-filter"
                [options]="supplierFilterOptions$ | async | notNull"
                formControlName="sellerKeys"
                [group]="invoicesFiltersFormGroup"
                [selectAllText]="allSuppliersI18n"
                [hideLabel]="true"
                [placeholder]="selectSupplierI18n"
            >
            </lsq-multi-select>
            <lsq-multi-select
                class="invoices-filters-status-filter"
                [options]="invoiceStatusFilterOptions"
                [floatLabel]="true"
                formControlName="invoicesFilter"
                [selectAllText]="allStatusesI18n"
                [hideLabel]="true"
                [placeholder]="selectStatusI18n"
            >
            </lsq-multi-select>
        </form>
        <span class="export-button" *ngIf="!(responsiveService.mdBelow | async)">
            <lsq-export-button
                [request]="listInvoicesDataSource.request"
                [service]="
                    isFinancingAccountPortalUser
                        ? getBuyerAccountInvoiceExportService
                        : getBuyerInvoiceSummaryExportService
                "
                [reportName]="reportName"
                [isIcon]="true"
                [disabled]="
                    onlyOpenAndRevokedCreditMemos ||
                    (listInvoicesDataSource.rows$ | async | notNull)?.length == 0 ||
                    (listInvoicesDataSource.loading$ | async | notNull)
                "
            ></lsq-export-button>
        </span>
    </div>
</ng-template>

<business-units-select-page-header></business-units-select-page-header>
<div class="container-fluid page-container">
    <div *ngIf="listInvoicesDataSource">
        <lsq-data-point-bar
            *featureFlag="featureFlags.BuyerInvoicesKPIs"
            [loading]="invoiceSummaryDataSource.loading$ | async | notNull"
            [dataPoints]="dataPoints$ | async | notNull"
            [isLeftAligned]="false"
        ></lsq-data-point-bar>

        <ng-container *ngIf="!!(tabsConfig$ | async)">
            <tabs
                *featureFlag="featureFlags.PendingCreditMemos"
                [tabsConfig]="(tabsConfig$ | async)!"
            ></tabs>
        </ng-container>

        <ng-container
            *ngIf="
                (activeTabLabel$ | async) === routeQueryParams.InvoicesTab ||
                (activeTabLabel$ | async) === undefined
            "
        >
            <card *ngIf="!(responsiveService.mdBelow | async)">
                <div right-header-content>
                    <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
                </div>

                <div card-body class="invoice-table">
                    <div card-body *ngIf="!initialized">
                        <lsq-circle-loader></lsq-circle-loader>
                    </div>
                    <lsq-data-table
                        *ngIf="initialized"
                        [hasHeader]="true"
                        [dataSource]="listInvoicesDataSource"
                        [isPaginated]="true"
                        [layoutFixed]="true"
                        [trackBy]="trackByInvoiceKey"
                        [appearance]="tableAppearance.Default"
                        [getRowClassName]="getRowClassNameBound"
                        [columnVisibilities]="{
                            buyerName: isFinancingAccountPortalUser,
                            Revoke: buyerAccountSharedService.canRevokeInvoices$ | async,
                            buyerDiscountAmount:
                                buyerAccountSharedService.isBuyerPaidEarlyPaymentFeePercentageShown$
                                | async,
                            buyerDiscountPercentage:
                                buyerAccountSharedService.isBuyerPaidEarlyPaymentFeePercentageShown$
                                | async,
                            invoiceFees: buyerAccountSharedService.isPayLaterEnabled$ | async,
                            payLaterDueDate: buyerAccountSharedService.isPayLaterEnabled$ | async
                        }"
                    >
                        <lsq-column
                            [column]="{
                                key: 'isGroup',
                                width: '4.5rem',
                                sortable: false
                            }"
                        >
                            <ng-template [custom-cell] let-row="row" let-index="index">
                                <div
                                    [class.counter]="row.refGroupedInvoiceKey && !row.isGroup"
                                    [style.padding-top]="row.isGroup ? 0 : undefined"
                                    [style.padding-bottom]="row.isGroup ? 0 : undefined"
                                >
                                    <ng-container *ngIf="row.isGroup">
                                        <div
                                            class="invoice-group-expand-button"
                                            [class.disabled]="invoiceGroupTogglesAreDisabled"
                                            [attr.tabindex]="0"
                                            (click)="handleInvoiceGroupToggleClick(row)"
                                        >
                                            <lsq-icon
                                                [type]="
                                                    expandedGroupInvoiceKeys.has(row.refInvoiceKey)
                                                        ? icons.ChevronDown
                                                        : icons.ChevronRight
                                                "
                                                [color]="color.Black"
                                            >
                                            </lsq-icon>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="row.refGroupedInvoiceKey">
                                        {{
                                            row
                                                | getOffsetIndexOfSiblingRow
                                                    : index
                                                    : 'refInvoiceKey'
                                                    : 'isGroup'
                                                | async
                                        }}
                                    </ng-container>
                                </div>
                            </ng-template>
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: businessUnitNameI18n,
                                key: 'buyerName',
                                truncateTextCss: true,
                                sortable: true
                            }"
                        >
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: supplierNameI18n,
                                key: 'sellerName',
                                truncateTextCss: true,
                                sortable: true,
                                onCellClick: goSupplierDetailsBound
                            }"
                        >
                        </lsq-column>

                        <lsq-column
                            [column]="{
                                header: invoiceNumberI18n,
                                key: 'invoiceNumber',
                                truncateAfter: invoiceNumberTruncateAfter$ | async | notNull,
                                reverseTruncate: true,
                                onCellClick: openInvoiceDetailsBound,
                                isClickableFunction: isInvoiceClickableBound,
                                sortable: true
                            }"
                        >
                        </lsq-column>

                        <lsq-date-column
                            [displayNullIfFieldIsTrue]="'isGroup'"
                            [isShortDate]="true"
                            [column]="{
                                header: invoiceDateI18n,
                                key: 'invoiceDate',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-date-column
                            [isShortDate]="true"
                            [column]="{
                                header: earlyPaidDateI18n,
                                key: 'earlyPaymentDate',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-date-column
                            [isShortDate]="true"
                            [column]="{
                                header: dueDateI18n,
                                key: 'invoiceDueDate',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-currency-column
                            [column]="{
                                header: invoiceAmountI18n,
                                key: 'finalApprovedAmount',
                                sortable: true
                            }"
                        >
                        </lsq-currency-column>

                        <lsq-column
                            [alignRight]="true"
                            [column]="{
                                header: buyerDiscountPercentageI18n,
                                key: 'buyerDiscountPercentage',
                                sortable: true,
                                headerPopoverContent: feeShareToolTipTextI18n,
                                popoverIcon: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <ng-container *ngIf="row.fundingStatus == 'EARLY_PAID'">
                                    <div>{{ row.buyerDiscountPercentage || 0 | lsqPercent }}</div>
                                </ng-container>
                                <ng-container *ngIf="row.fundingStatus != 'EARLY_PAID'">
                                    <div>----</div>
                                </ng-container>
                            </ng-template>
                        </lsq-column>

                        <lsq-column
                            [alignRight]="true"
                            [column]="{
                                header: buyerDiscountAmountI18n,
                                key: 'buyerDiscountAmount',
                                sortable: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <ng-container *ngIf="row.fundingStatus == 'EARLY_PAID'">
                                    <div>
                                        {{
                                            row.buyerDiscountAmount?.cents / 100 || 0 | lsqCurrency
                                        }}
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="row.fundingStatus != 'EARLY_PAID'">
                                    ----
                                </ng-container>
                            </ng-template>
                        </lsq-column>

                        <lsq-column
                            [alignRight]="true"
                            [column]="{
                                header: invoiceFeesI18n,
                                key: 'invoiceFees',
                                sortable: false
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                {{ row.invoiceFees | lsqCurrency }}
                            </ng-template>
                        </lsq-column>

                        <lsq-date-column
                            [isShortDate]="true"
                            [column]="{
                                header: payLaterDueDateI18n,
                                key: 'payLaterDueDate',
                                sortable: true
                            }"
                        >
                        </lsq-date-column>

                        <lsq-column
                            [column]="{
                                header: invoiceStatusI18n,
                                key: 'fundingStatus',
                                width: '11rem',
                                sortable: true
                            }"
                        >
                            <ng-template [custom-cell] let-row="row">
                                <ng-container
                                    *ngIf="
                                        row.invoiceAmount?.cents < 0 &&
                                            !row.isGroup &&
                                            row.fundingStatus != 'REVOKED';
                                        else regularStatus
                                    "
                                >
                                    <status-pill
                                        [status]="creditMemoStatus"
                                        [color]="statusColor.CREDIT_MEMO"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-container>
                                <ng-template #regularStatus>
                                    <status-pill
                                        *ngIf="
                                            row.fundingStatus === ineligibleStatus &&
                                            (buyerAccountSharedService.isPayLaterEnabled$ | async)
                                        "
                                        [status]="row.fundingStatus"
                                        [color]="statusColor[row.fundingStatus] || processingColor"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                        popover="{{ row.ineligibilityReason }}"
                                    >
                                    </status-pill>
                                    <status-pill
                                        *ngIf="
                                            row.fundingStatus != ineligibleStatus ||
                                            !(buyerAccountSharedService.isPayLaterEnabled$ | async)
                                        "
                                        [status]="row.fundingStatus"
                                        [color]="statusColor[row.fundingStatus] || processingColor"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-template>
                            </ng-template>
                        </lsq-column>

                        <lsq-button-column
                            [column]="{
                                header: revokeHeaderI18n,
                                key: 'Revoke',
                                width: '7rem'
                            }"
                            (buttonClick)="handleRevokeClick($event)"
                            [hideButton]="revokeButtonIsHiddenBound"
                            [disableButton]="revokeButtonIsDisabledBound"
                            [icon]="icons.CloseSmall"
                        >
                        </lsq-button-column>
                    </lsq-data-table>
                </div>
            </card>

            <div *ngIf="responsiveService.mdBelow | async">
                <ng-container *ngTemplateOutlet="filtersForm"></ng-container>
                <lsq-data-table-mobile
                    [dataSource]="listInvoicesDataSource"
                    [isPaginated]="true"
                    [cardsAreClickable]="true"
                    [cardsAreExpandable]="true"
                >
                    <ng-template #mobileCardHeader let-row="row">
                        <div class="invoices-header-mobile">
                            <div class="mtc-header-content-left">
                                <div class="mtc-header-title">
                                    <a
                                        class="p not-bold supplier-name"
                                        (click)="goSupplierDetails(row)"
                                        queryParamsHandling="preserve"
                                    >
                                        {{ row.sellerName }}
                                    </a>
                                </div>
                                <div class="mtc-header-sub-title">
                                    <div class="text-truncate" [style.maxWidth]="'30rem'">
                                        <span *ngIf="!isInvoiceClickableBound(row)">{{
                                            row.invoiceNumber
                                        }}</span>

                                        <a
                                            *ngIf="!isInvoiceClickableBound(row)"
                                            (click)="openInvoiceDetailsBound(row)"
                                            >{{ row.invoiceNumber }}</a
                                        >
                                    </div>
                                    <strong>{{ row.invoiceAmount | lsqCurrency }}</strong>
                                </div>
                            </div>
                            <div class="mtc-header-content-right">
                                <ng-container
                                    *ngIf="
                                        row.finalApprovedAmount?.cents < 0 &&
                                            !row.isGroup &&
                                            row.buyerApprovalStatus != 'REJECTED';
                                        else regularStatus
                                    "
                                >
                                    <status-pill
                                        [status]="creditMemoStatus"
                                        [color]="statusColor.CREDIT_MEMO"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-container>
                                <ng-template #regularStatus>
                                    <status-pill
                                        [status]="row.fundingStatus"
                                        [color]="statusColor[row.fundingStatus] || processingColor"
                                        [displayValueMap]="invoiceFundingStatusDisplay"
                                    >
                                    </status-pill>
                                </ng-template>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #mobileCardColumns let-row="row">
                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceDateI18n }}
                            </div>
                            <div class="card-item-value">
                                {{
                                    row.invoiceDate && !row.isGroup
                                        ? (row.invoiceDate | date : lsqShortDateFormat)
                                        : nullValue
                                }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ earlyPaidDateI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.fundingDate | date : lsqShortDateFormat }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ dueDateI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.invoiceDueDate | date : lsqShortDateFormat }}
                            </div>
                        </div>

                        <ng-template *ngIf="buyerAccountSharedService.isPayLaterEnabled$ | async">
                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ invoiceFeesI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.invoiceFees | lsqCurrency }}
                                </div>
                            </div>

                            <div class="card-item">
                                <div class="card-item-label">
                                    {{ payLaterDueDateI18n }}
                                </div>
                                <div class="card-item-value">
                                    {{ row.payLaterDueDate | date : lsqShortDateFormat }}
                                </div>
                            </div>
                        </ng-template>
                    </ng-template>
                    <ng-template
                        #mobileCardFooter
                        let-row="row"
                        *ngIf="buyerAccountSharedService.canRevokeInvoices$ | async"
                    >
                        <div class="mtc-footer-link" *ngIf="!revokeButtonIsHiddenBound(row)">
                            <lsq-button
                                appearance="transparent"
                                (buttonClick)="handleRevokeClick(row)"
                                i18n="Table column button to revoke invoices"
                            >
                                Revoke Invoice
                            </lsq-button>
                        </div>
                    </ng-template>
                </lsq-data-table-mobile>
            </div>
        </ng-container>
        <ng-container *ngIf="(activeTabLabel$ | async) === routeQueryParams.PendingCreditMemosTab">
            <supply-chain-direct-account-pending-credit-memos></supply-chain-direct-account-pending-credit-memos>
        </ng-container>
    </div>
</div>
